import { useUtils } from "@/app/hooks/useUtils";
const MembershipDetailComponent = ({
    membershipId,
    membershipCards,
    membershipOverride,
    scrollRef,
}: {
    membershipId?: string | null;
    membershipCards?: any[];
    membershipOverride?: any;
    scrollRef?: React.RefObject<HTMLDivElement>;
}) => {

    const { veticDateFormat } = useUtils()

    const membership =
        membershipOverride ??
        membershipCards?.find(
            (m: any) => String(m.user_membership_id) === String(membershipId)
        );

    if (!membership) return null;

    const usages = membership.exhaustible_coupons_usages ?? [];
    const shouldScroll = usages.length > 4;
    return (
        <div className="w-full min-h-0 flex flex-col px-[100px] pt-[25px] pb-2 mt-[10px] font-roboto ">

            {/* TOP */}
            <p className="text-[24px] text-[rgba(240,91,114,1)] font-semibold mb-2">
                Hi, Check utilization details below
            </p>

            {/* HEADER */}
            <div className="flex justify-between items-start mb-4 mt-[20px]">
                <div>
                    <h2 className="text-[28px] font-semibold text-slate-800">
                        {membership.category} Package
                    </h2>

                    {membership.created_on && (
                        <p className="text-[20px] font-medium mt-[10px]">
                            Purchased on: {veticDateFormat(membership.created_on?.slice(0, 10))}
                        </p>
                    )}
                </div>

                <div className="flex flex-col items-end gap-1">

                    {membership.status && <span
                        className={`
    text-[22px] px-5 py-[5px] rounded-[10px] font-medium
    ${membership.status?.toLowerCase() === "active"
                                ? "bg-[rgba(214,255,210,1)] text-[rgba(64,156,24,1)]"
                                : membership.status?.toLowerCase() === "exhausted" || membership.status?.toLowerCase() === "expired"
                                    ? "bg-[rgba(255,221,216,1)] text-[rgba(255,121,103,1)]"
                                    : "bg-gray-100 text-gray-600"
                            }
  `}
                    >
                        {membership.status}
                    </span>}


                    {membership.expire_on && (
                        <p className="text-[20px] font-medium">
                            Expires on: {veticDateFormat(membership.expire_on?.slice(0, 10))}
                        </p>
                    )}
                </div>
            </div>
            {
                usages.length > 0 ?
                    (<div className="flex justify-between px-10 mt-[35px] text-[20px] mb-2">
                        <span className="pl-[20px]">SERVICE</span>
                        <span>CLINIC</span>
                        <span className="pr-[30px]">DATE</span>
                    </div>) :
                    <></>
            }

            {/* TABLE HEADER */}



            <div
                ref={scrollRef}
                data-mirror-membership-detail-scroll="true"
                className={`
    space-y-4 pr-1 mb-[12px]
    ${shouldScroll ? "h-[360px] overflow-y-auto" : ""}
  `}
            >
                {usages.length === 0 ? (
                    <div className="flex justify-center items-center h-[400px] text-[28px] text-gray-500 font-medium">
                        No benefits used yet
                    </div>
                ) : (
                    usages.map((usage: any, i: number) => (
                        <div
                            key={i}
                            className="grid grid-cols-[2fr_2fr_1fr] items-center justify-evenly px-2 py-3
        border border-[rgba(213,213,213,1)] h-[77px] rounded-[20px] bg-slate-50 text-[12px]"
                        >
                            <div className="flex items-center gap-2 pl-[20px]">
                                <span className="font-semibold text-[24px]">
                                    {usage.pet_name}'s {usage.display_text?.slice(0, 12)}
                                </span>

                                {usage.in_cart && (
                                    <span className="text-[18px] text-[rgba(240,91,114,1)] bg-[rgba(255,233,236,0.65)] px-3 py-[2px] rounded-[10px] font-semibold">
                                        in this cart
                                    </span>
                                )}
                            </div>

                            <span className="font-medium text-[24px] truncate">
                                {usage.clinic_name}
                            </span>

                            <span className="text-right font-medium text-[24px] pr-[20px]">
                                {veticDateFormat(usage.used_at?.slice(0, 10))}
                            </span>
                        </div>
                    ))
                )}
            </div>        </div>
    );
};

export default MembershipDetailComponent;
